import httpService from '@Utils/httpService';

const baseUrl = 'api/PointClouds';

export default {
	add(data) {
		return httpService.post({
			url: baseUrl,
			data,
		});
	},
	update(data) {
		if (!data.id) return this.add(data);
		return httpService.put({
			url: `${baseUrl}/${data.id}`,
			data,
		});
	},
}